module.exports = __webpack_public_path__ + "img/043-knife.1c8feb90.png";